import { api } from '../../axios.instance';

export const exportStaff = () => {
  return api.get('/staff/export', { responseType: 'blob' });
};
